<template>
  <div class="customNotice-container">
    <!-- 搜索栏 -->
    <el-row>
      <el-form
        size="medium"
        ref="noticeForm"
        :model="noticeForm"
        inline
        @submit.native.prevent
      >
        <el-form-item prop="plateNum" class="r-20">
          <el-input
            v-model.trim="noticeForm.plateNum"
            placeholder="请输入车牌号"
            @keyup.enter.native="query"
          ></el-input>
        </el-form-item>
        <el-form-item prop="propertyOwner" class="r-20">
          <el-input
            v-model.trim="noticeForm.propertyOwner"
            placeholder="请输入通知对象"
            @keyup.enter.native="query"
          ></el-input>
        </el-form-item>
        <el-form-item prop="date" class="r-20">
          <el-date-picker
            class="selectDate"
            v-model="noticeForm.date"
            :picker-options="pickerOptions"
            clear-icon="el-icon-circle-close"
            value-format="yyyy-MM-dd"
            type="date"
            placeholder="请输入修改日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item prop="account" class="r-20">
          <el-input
            v-model.trim="noticeForm.account"
            placeholder="请输入修改账号"
            @keyup.enter.native="query"
          ></el-input>
        </el-form-item>
        <el-button type="primary" @click="query">查询</el-button>
        <el-button @click="resetForm">取消</el-button>
      </el-form>
    </el-row>
    <!-- 新增通知栏 -->
    <el-row>
      <el-button type="primary" @click="addNotice">新增通知</el-button>
    </el-row>
    <!-- 表格栏 -->
    <el-row class="table-column">
      <el-table
        ref="multipleTable"
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
        size="mini"
        height="600px"
        stripe
      >
        <el-table-column
          label="序号"
          type="index"
          align="center"
          width="40"
        ></el-table-column>
        <el-table-column
          prop="plateNum"
          label="车牌号"
          min-width="200"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="msgName"
          label="模板名称"
          min-width="120"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="msg"
          label="消息模板"
          min-width="240"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="noticeName"
          label="通知对象"
          min-width="140"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column label="通知方式" min-width="90">
          <template>
            <span>短信</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="dateModified"
          label="修改日期"
          min-width="150"
        ></el-table-column>
        <el-table-column
          prop="account"
          label="修改账号"
          min-width="100"
        ></el-table-column>
        <el-table-column label="操作" width="120" fixed="right">
          <template slot-scope="{ row }">
            <el-button type="text" @click.stop="editor(row)">编辑</el-button>
            <el-button type="text" class="delete-btn" @click.stop="delData(row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <!-- 分页 -->
    <el-row>
      <el-pagination
        class="customNotice-pagination"
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage"
        :page-size="limit"
        layout="total, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "CustomNotice",
  data() {
    return {
      noticeForm: {
        plateNum: "",
        date: "",
        propertyOwner: "",
        account: "",
      },
      // 将来、未到的日期禁止选中
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      tableData: [],
      currentPage: 1,
      limit: 10,
      total: 0,
    };
  },
  created() {
    this.getTableData();
  },
  methods: {
    query() {
      // console.log(this.noticeForm);
      this.getTableData();
    },
    resetForm() {
      this.$resetForm(this, "noticeForm");
      this.getTableData();
    },
    addNotice() {
      // 跳转到新增通知页面
      this.$router.push({ path: "/addNotice" });
    },
    editor(row) {
      // 跳转到新增通知页面
      this.$router.push({
        name: "AddNotice",
        params: {
          plateNum: row.plateNum,
          sysMsgId: row.sysMsgId,
          noticeId: row.noticeId,
        },
      });
      sessionStorage.setItem("noticeEditId", row.id);
      sessionStorage.setItem("noticePlateNum", row.plateNum);
      sessionStorage.setItem("noticeSysMsgId", row.sysMsgId);
      sessionStorage.setItem("noticeId", row.noticeId);
    },
    delData(row) {
      this.$confirm("确定删除吗？", "系统提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          // 删除接口
          let { data: res } = await this.$axios.delete(
            "/api/custom/notifications/delete?id=" + row.id
          );
          if (res.code == 1) {
            this.$message({ type: "success", message: "删除成功!" });
            // 刷新表格数据
            let totalPage = Math.ceil((this.total - 1) / 10);
            let currentPage =
              this.currentPage > totalPage ? totalPage : this.currentPage;
            this.currentPage = currentPage < 1 ? 1 : currentPage;
            this.getTableData();
          } else {
            this.$message.warning(res.msg);
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 获取表格数据
    async getTableData() {
      let obj = {};
      obj.plateNum = this.noticeForm.plateNum;
      obj.dateModified = this.noticeForm.date;
      obj.noticeName = this.noticeForm.propertyOwner;
      obj.account = this.noticeForm.account;
      obj.page = this.currentPage;
      obj.limit = this.limit;
      let { data: res } = await this.$axios.get(
        "/api/custom/notifications/list",
        {
          params: obj,
        }
      );
      if (res.code == 1) {
        this.tableData = res.data.list;
        this.total = res.data.totalCount;
      } else {
        this.$message.warning(res.msg);
      }
    },
    //页数改变时触发
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`);
      this.currentPage = val;
      this.getTableData();
    },
  },
};
</script>

<style lang="scss" scoped>
.customNotice-container {
  height: calc(100% - 40px);
  margin: 20px;
  padding: 20px;
  background: #fff;
  box-sizing: border-box;
  .selectDate {
    /deep/ .el-input__inner {
      padding-left: 15px;
    }
    /deep/ .el-input__prefix {
      color: #333;
      // 设置默认值消除原来格式的影响
      left: auto;
      right: 5px;
      .el-icon-time:before {
        content: "\e78e";
      }
    }
    /deep/.el-input__suffix {
      .el-input__icon.el-icon-circle-close {
        line-height: 32px;
        display: none;
      }
    }
  }
  .table-column {
    margin-top: 20px !important;
    .delete-btn {
      color: #ff0000;
    }
  }
  .customNotice-pagination {
    margin-top: 10px;
  }
}
</style>
